export const gtmEvents = {
  addTag: 'add_tag',
  btn: 'btn',
  checkFreshData: 'check_fresh_data',
  closeInfoModal: 'close_info_modal',
  filterChange: 'filter_change',
  freshDataAvailable: 'fresh_data_available',
  openInfoModal: 'open_info_modal',
  removeTag: 'remove_tag',
  shortcut: 'shortcut',
  showedColumnChange: 'showed_column_change',
  tableCellSearch: 'table_cell_search',
  tableSort: 'table_sort',
  toggleTheme: 'toggle_theme',
};
